exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_8456f22,.textarea_ef34879{width:280px!important}.textarea_ef34879{height:100px}.textarea_ef34879 .k-textarea{height:100px!important;resize:none}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_8456f22",
	"textarea": "textarea_ef34879"
};